import script from "./ViewingHistoryKit.vue?vue&type=script&lang=js"
export * from "./ViewingHistoryKit.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__